module.exports = __webpack_public_path__ + "img/step04.e97fd8f0.png";